import * as React from 'react';
import KNB from '@wmfe/mach-pro-knb';

const SLCompass = Mach.requireModule('SLCompass');

/**
 * 拍平arr
 * @param arr
 * @returns Array
 */
function flattenTest(arr: any[]) {
  const result: string[] = [];
  for (let i = 0; i < arr.length; i++) {
    if (Array.isArray(arr[i])) {
      result.push(...flattenTest(arr[i]));
    } else {
      result.push(arr[i]);
    }
  }
  return [...new Set(result)];
}

/**
 * 使用KNB获取storage
 * @param key 新旧两个key值
 * @returns
 */
function getKNBStorage(key: string): Promise<{ result: string[] | undefined; }> {
  let resultAll;
  const resultSet = new Set();
  return new Promise<any>((resolve) => {
    KNB.getStorage({
      key,
      success(result) {
        if (result.value) {
          resultSet.add(JSON.parse(result.value));
          resultAll = flattenTest([...resultSet]);
        }
        resolve(resultAll);
      },
    });
  });
}

/**
 * 获取新旧两种历史搜索词的storage并去重和整合
 * @param arr 当前输入的搜索词
 * @returns
 */
function getHistory(arr?): Promise<string[]> {
  return new Promise<any>(async (resolve) => {
    const resultSet = new Set();
    if (arr) {
      const newKeyword = arr.trim();
      resultSet.add(newKeyword);
    }
    // const resultOld = await getKNBStorage('history');
    const resultNew = await getKNBStorage('sailor_c_search_keyword_history');
    // console.log('resultNew🐶', resultNew);
    !!resultNew && resultSet.add(resultNew);
    // !!resultOld && resultSet.add(resultOld);
    let historyArr = flattenTest([...resultSet]);
    // console.log('historyArr🐱', historyArr, historyArr.length);
    historyArr = historyArr.slice(0, 15);
    resolve(historyArr);
  });
}

/**
 * 清空两种类型的数据存储
 * @returns
 */
function clearHistory(): Promise<boolean> {
  return new Promise<any>(async (resolve) => {
    KNB.clearStorage({
      key: 'history',
      success() {
        KNB.clearStorage({
          key: 'sailor_c_search_keyword_history',
          success() {
            // console.log("clear成功🎉")
            resolve(true);
          },
        });
      },
    });
  });
}

/**
 * 存储数据
 * @param arr 当前输入的文本
 */
function setHistory(arr?): Promise<boolean> {
  return new Promise<any>((resolve) => {
    KNB.setStorage({
      key: 'sailor_c_search_keyword_history',
      value: JSON.stringify(arr),
      level: 1,
      success() {
        // console.log("set成功🎉",arr)
        resolve(true);
      },
    });
  });
}

const debounce = (fn, timeout = 200) => {
  let timer;
  return function (this, ...args: any[]) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, timeout);
  };
};

const MPStorage = Mach.requireModule('Storage');
const sailor_c_search_selected_tab_info_key = 'sailor_c_search_selected_tab_info_key';
function getSelectedTabInfo() {
  const resultNew = MPStorage?.getDictionary({ channel: 'search', key: sailor_c_search_selected_tab_info_key });
  return resultNew;
}

function saveSelectedTabInfo(tabInfo: any) {
  MPStorage?.setDictionary({ channel: 'search', key: sailor_c_search_selected_tab_info_key, value: tabInfo });
}

function clearSelectedTabInfo() {
  MPStorage?.remove?.({ channel: 'search', key: sailor_c_search_selected_tab_info_key });
}

function getShopInfoItemWithRender(shopInfo: any, shopInfoItem: string) {
  if (shopInfo?.shopBasicLabelOrder
    && shopInfo?.[`${shopInfoItem}`]
    && shopInfo?.shopBasicLabelOrder.includes(`${shopInfoItem}`)
  ) {
    switch (true) {
      case shopInfoItem === 'shopSaleInfo':
        return shopInfo?.shopSaleInfo?.displayText;
      case shopInfoItem === 'shopAvgSpend':
        return shopInfo?.shopAvgSpend;
      default:
        return '-999';
    }
  } else {
    return '-999';
  }
}

function checkRegionEqual(region?: string) {
  if (!region) {
    return false;
  }
  let { region: compassRegion } = SLCompass?.getCompassInfo() || {};
  compassRegion = compassRegion ? compassRegion.toLowerCase() : '';
  return region.toLowerCase() === compassRegion;
}

function isSARegion() {
  return checkRegionEqual('SA');
}
function isMGRegion() {
  return checkRegionEqual('MG');
}

export {
  getHistory,
  clearHistory,
  setHistory,
  getSelectedTabInfo,
  saveSelectedTabInfo,
  clearSelectedTabInfo,
  debounce,
  getShopInfoItemWithRender,
  isMGRegion,
  isSARegion,
};
